// Thin wrapper around the student_profile_service API (docs/DECISIONS.md,
// "student-facing UI batch: curriculum rebrand + registration"), mirroring
// api.js's apiFetch/origin-constant style.

import { apiFetch, STUDENT_PROFILE_SERVICE_ORIGIN } from './api';

export async function checkHasProfile() {
  const response = await apiFetch('/api/student-profile/exists', {}, STUDENT_PROFILE_SERVICE_ORIGIN);
  if (!response.ok) return false;
  const body = await response.json();
  return Boolean(body.exists);
}

export async function getProfile() {
  const response = await apiFetch('/api/student-profile', {}, STUDENT_PROFILE_SERVICE_ORIGIN);
  if (!response.ok) return null;
  return response.json();
}

export async function submitProfile(payload) {
  return apiFetch(
    '/api/student-profile',
    { method: 'POST', body: JSON.stringify(payload) },
    STUDENT_PROFILE_SERVICE_ORIGIN
  );
}
